/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AllowedDenied {
    Denied = 'Denied',
    Allowed = 'Allowed'
}

export function AllowedDeniedFromJSON(json: any): AllowedDenied {
    return AllowedDeniedFromJSONTyped(json, false);
}

export function AllowedDeniedFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllowedDenied {
    return json as AllowedDenied;
}

export function AllowedDeniedToJSON(value?: AllowedDenied | null): any {
    return value as any;
}

